import React, { useCallback, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { createCSV} from '../../../../utilities/general';
import LoadingSpinner from '../../../shared/LoadingSpinner';
import { submitQueryExecute } from '../../../../redux/actions/supportActions';
import { connect } from 'react-redux';
import '../../../../scss/partials/shared/tables/reportsTableStyles.css';
import Table from '../../../shared/table/Table';
import Button, {
  buttonTypes,
  buttonSizes,
  buttonTextSizes,
} from '../../../shared/Button';
import { searchCatalog } from './query-utils';
import QueryContext from './query-context';
import { useParams } from 'react-router-dom';

function UnconnectedQueryReport({dispatch}) {
  const [queryResults, setQueryResults] = React.useState();
  const { id } = useParams()
  console.log('QueryReport: item.id: ', id);
  const {catalog} = React.useContext(QueryContext)
  const item = searchCatalog(id, catalog)

  const executeQuery = useCallback(() =>
    id &&
    dispatch(
      submitQueryExecute({
        queryId: id,
        urlParams: item?.formData,
        setStateFunc: setQueryResults,
      })
    ), [id, dispatch, item?.formData]);

  useEffect(() => {
    console.log('useEffect: Executing query for item: ', item);
    executeQuery();
    // const timerId = setTimeout(() => {
    //   executeQuery();
    // }, 2000);
  }, [executeQuery, item]);

  if (!item || queryResults === undefined) {
    return (
      <div className="loading-spinner__user-list-container">
        <LoadingSpinner />
      </div>
    );
  }

  const queryResultsObj = JSON.parse(queryResults);

  if (!queryResultsObj || queryResultsObj.length === 0) {
    return (
      <div className="container">
        <div className="layout-container content-container content-container--column content-container--shadow">
          <FormattedMessage
            id="query.noResults"
            defaultMessage="No results found for the query."
            description="Message displayed when no results are returned from the query."
          />
        </div>
      </div>
    );
  }


  const columnNames = Object.keys(queryResultsObj[0]);
  console.log('columnNames: ', columnNames);

  const tableData = queryResultsObj.map((row) => {
    //console.log('row: ', row);
    let rowObj= {}
    for (const col of columnNames) {
      //console.log('col: ', col);
      rowObj[col] = {
        sortBy: row[col],
        display: row[col],
      }
    }
    return rowObj
  })

  //console.log('tableData: ', tableData);

  const tableHeadings = columnNames.map((nm, index) => ({
    isSortable: true,
    sortBy: nm,
    display: nm,
  }))
  
  const csvHeaders = columnNames
  const sortParam = columnNames[0]
  const csvData = queryResultsObj.map((row) => {
    let rowArray= []
    for (const col of columnNames) {
      rowArray.push(row[col])
    }
    return rowArray
  })

  function triggerCSV() {
    return createCSV(csvHeaders, csvData, 'query_report');
  }

  const table = (
    <Table
      hasTableHead={true}
      hasSelector={false}
      tableHeadings={tableHeadings}
      sortParam={sortParam}
      tableData={tableData}

      tableStyles={`table table-layout__${columnNames.length}-column`}
    />
  )

  const tableJSX = (
    <>
      <div className="table__header padding-10 flex-spread">
        <div className="vertical-center text-large text-bold" style={{flexGrow: 1}}>
          {item.title}
        </div>
        <div className="flex-end">
          <Button
            onClick={triggerCSV}
            text="CSV"
            buttonType={buttonTypes.secondaryReversed}
            buttonSize={buttonSizes.small}
            buttonTextSize={buttonTextSizes.extraSmall}
          />
        </div>
      </div>
      <div className="item-container__main-text text-large text-light flex-spread margin-bottom-10">
        {table}
      </div>
    </>
  )
  
  return (
    <>
      <div className="content-display__container">
        <div className="content-display__column">
          {tableJSX}
        </div>
      </div>
    </>
  )

} //UnconnectedQueryReport

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps)(UnconnectedQueryReport);
